import { Phone } from 'lucide-react';
import Navbar from '../components/Navbar';
import Hero from '../components/Hero';
import Services from '../components/Services';
import Process from '../components/Process';
import Gallery from '../components/Gallery';
import Testimonials from '../components/Testimonials';
import WhyChoose from '../components/WhyChoose';
import ServiceArea from '../components/ServiceArea';
import FAQ from '../components/FAQ';
import QuoteForm from '../components/QuoteForm';
import JobberQuoteEmbed from '../components/JobberQuoteEmbed';
import BookingForm from '../components/BookingForm';
import Footer from '../components/Footer';
import About from '../components/About';
import ReviewCTA from '../components/ReviewCTA';
import { COMPANY } from '../mock/data';

export default function Home() {
  return (
    <div className="bg-ink text-cream antialiased">
      <Navbar />
      <Hero />
      <Services />
      <Process />
      <Gallery />
      <WhyChoose />
      <Testimonials />
      <ReviewCTA />
      <ServiceArea />
      <About />
      <FAQ />
      <BookingForm />
      <JobberQuoteEmbed />
      <Footer />

      <a
        href={`tel:${COMPANY.phoneRaw}`}
        className="lg:hidden fixed bottom-5 right-5 z-40 bg-gold text-ink rounded-full shadow-2xl px-5 py-3 font-bold uppercase tracking-wider text-sm flex items-center gap-2 hover:scale-105 transition-transform"
      >
        <Phone className="w-4 h-4" /> Call Now
      </a>
    </div>
  );
}
